(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('IndicatorFileDialogController', IndicatorFileDialogController);

    IndicatorFileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'IndicatorFile'];

    function IndicatorFileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, IndicatorFile) {
        var vm = this;

        vm.indicatorFile = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        
        
        vm.zipFile = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.indicatorFile.id !== null) {
                IndicatorFile.update(vm.zipFile, onSaveSuccess, onSaveError);
            } else {
                IndicatorFile.save(vm.zipFile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:indicatorFileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


		 vm.setFile = function ($file, zipFile) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                    	zipFile.filename = $file.name;
                        zipFile.file = base64Data;
                        zipFile.fileContentType = $file.type;
                    });
                });
            }
        };

    }
})();
